import { GuardedRouteConfig, Route } from '@/core/types';
import { AccessGranted } from '@/features/auth/hooks/useAuthorization';

const isGuardSatisfied = (
  guarded: boolean | GuardedRouteConfig,
  isAccessGranted: AccessGranted,
) => {
  if (typeof guarded === 'boolean') return true;
  return isAccessGranted({ feature: guarded.feature });
};

export const findFirstAvailableRoute = (
  routes: Route[] | undefined,
  isAccessGranted: AccessGranted,
): Route | undefined =>
  routes?.find(
    (route) => route.potentialFallbackRoute && isGuardSatisfied(route.guarded, isAccessGranted),
  );
